import { render, staticRenderFns } from "./edit-court.vue?vue&type=template&id=78597232&scoped=true&"
import script from "./edit-court.vue?vue&type=script&lang=ts&"
export * from "./edit-court.vue?vue&type=script&lang=ts&"
import style0 from "./edit-court.vue?vue&type=style&index=0&id=78597232&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78597232",
  null
  
)

component.options.__file = "edit-court.vue"
export default component.exports